import type { ICreateArticleProductionSiteAllocation } from "@/data/commands/catalog/CreateArticleCmd";
import { Factory } from "@/data/dao/Factory";
import { CatalogDao } from "@/data/dao/service/CatalogDao";
import { RoomDao } from "@/data/dao/service/RoomDao";
import type { IArticleProductionSiteAllocation } from "@/data/model/Article";
import type { IProductionSite } from "@/data/model/ProductionSite";
import type { IRoom } from "@/data/model/Room";

import { i18n } from "@/portal/Trans";
import { Select } from "@/portal/formControls/Select";

export class ArticleProductionSiteAllocatorRow {
    private $element: JQuery;
    private productionSiteSelect: Select<IProductionSite>;
    private roomsSelect: Select<IRoom>;

    constructor(parent: JQuery, onRemove: { (): void }) {
        this.$element = $('<div class="article-production-site-allocator-row"/>').appendTo(parent);
        const container = $('<div class="form-group row"></div>').appendTo(this.$element);
        $(
            '<label class="col-xl-3 col-lg-3 col-form-label">' + i18n("general.entities.productionSite") + "</label>"
        ).appendTo(container);

        const row = $('<div class="row"></div>').appendTo(
            $('<div class="col-lg-9 col-xl-7"></div>').appendTo(container)
        );
        const inputContainer = $('<div class="col-md-4"></div>').appendTo(row);
        const productionSiteInput = $('<select name="productionsite" class="form-control"/>').appendTo(inputContainer);

        const roomsContainer = $('<div class="col-md-8 row"></div>').appendTo(row);
        $(
            '<label class="col-form-label ml-2">' +
                i18n("elements.productionSiteAllocator.printOrdersFrom") +
                "</label>"
        ).appendTo(roomsContainer);
        const roomsSelectContainer = $('<div class="col-md-8" style="display: flex;"></div>').appendTo(roomsContainer);
        $('<select name="productionsiteroom" class="form-control"></select>').appendTo(roomsSelectContainer);

        const removeBtn = $(
            '<div class="ml-4 mt-1"><a class="btn btn-sm btn-danger btn-icon btn-icon-md"><i class="la la-trash"></i></a></div>'
        )
            .appendTo(roomsContainer)
            .find("> .btn");
        removeBtn.click((e) => {
            e.preventDefault();
            e.stopPropagation();

            onRemove();
            container.remove();
        });

        this.productionSiteSelect = Select.createFromSelect(
            productionSiteInput,
            Factory.getInstance<CatalogDao>(CatalogDao).productionSiteDataSource,
            (c) => c.name,
            false
        );

        this.roomsSelect = Select.createFromSelect(
            roomsSelectContainer.find('.form-control[name="productionsiteroom"]'),
            Factory.getInstance<RoomDao>(RoomDao),
            (c) => c.name,
            false,
            i18n("offerSchedule.allRooms"),
            undefined,
            true
        ) as any;
    }

    public setValue(model?: IArticleProductionSiteAllocation) {
        const selectedRooms = model == null ? new Array<string>() : model.roomIds;
        this.roomsSelect.setValues(selectedRooms);

        this.productionSiteSelect.setValue(model?.productionSite?.id);
    }
    
    public validateRow(): boolean {
        this.productionSiteSelect.setError(false);
        const selectedProductionSiteId = this.productionSiteSelect.getValue();

        if (selectedProductionSiteId == null) {
            this.productionSiteSelect.setError(true);
            return false;
        }
        
        return true;
    }

    public getValues(): ICreateArticleProductionSiteAllocation {
        const selectedRooms = this.roomsSelect.getValues();
        const selectedProductionSiteId = this.productionSiteSelect.getValue();
        
        return {
            productionSiteId: selectedProductionSiteId!,
            roomIds: selectedRooms,
        };
    }
}
